<template>
    <v-container fluid>
        <v-row dense>
            <v-col class="d-flex" cols="12" sm="3">
                <v-select v-model="semestre" hide-details @change="selectSemestre" :items="semestres"
                    label="Filtre por Semestre" item-value="Id" item-text="Nombre" return-object dense />
            </v-col>
            <v-spacer></v-spacer>
            <v-btn :loading="lgExcel" color="green" dark @click="descargarExcel">
                <v-icon left>mdi-download</v-icon>
                Descargar </v-btn>
        </v-row>
        <v-data-table :headers="headers" :items="datos" item-key="Id" show-expand :single-expand="true"
            @item-expanded="onExpand" dense :search="filtro" :custom-filter="filtroTabla">
            <template v-slot:top>
                <v-text-field v-model="filtro" label="Filtro en listado"  style="max-width: 300px;" clearable ></v-text-field>
            </template>
            <!-- Fila expandida -->
            <template v-slot:expanded-item="{ headers, item }">
                <td :colspan="headers.length" class="px-4 py-3"
                    style="background: #f8fbff; border-top: 1px solid #d5e3f3;">
                    <!-- Loader mientras trae datos -->
                    <div v-if="loadingRow === item.Id">
                        Cargando detalles...
                    </div>

                    <!-- Render de datos -->
                    <div v-else-if="details[item.Id]" class="expanded-bg pa-4">
                        <div style="display: flex; gap: 20px;">
                            <div style="flex: 1; border-right: 1px solid #ccc;">
                                <strong>Disponibilidad</strong>
                                <DisponibilidadDetalle :items="details[item.Id].Disponibilidad" :docenteId="item.Id" />
                            </div>

                            <div style="flex: 2;" class="pl-3">
                                <strong>Comisiones</strong>
                                <ComisionesDetalle :items="details[item.Id].Comisiones" />
                            </div>

                        </div>
                    </div>

                    <!-- Si no trae nada -->
                    <div v-else>
                        No hay detalles disponibles.
                    </div>
                </td>
            </template>
        </v-data-table>
    </v-container>
</template>

<script>
import DisponibilidadDetalle from "@/components/disponibilidad/DisponibilidadDetalle.vue"
import ComisionesDetalle from "@/components/disponibilidad/ComisionesDetalle.vue"
import DisponibilidadService from "../../services/Disponibilidad.service"

export default {
    name: "TablaSimpleExpand",
    components: {
        DisponibilidadDetalle,
        ComisionesDetalle
    },
    data() {
        return {
            filtro: '',
            expandedRow: null,
            headers: [
                { text: "ID", value: "Id" },
                { text: "DNI", value: "dni" },
                { text: "Apellido y Nombre", value: "ApellidoNombre" },
                { text: "Disp.", value: "cantidad_disponibilidad" },
                { text: "Comisiones", value: "cantidad_comisiones" },
                { text: "Diferencia", value: "diferencia" },
            ],
            datos: [],
            semestre: null,
            semestres: this.$store.semestres,
            loadingRow: null,
            details: {},
            lgExcel: false
        }
    },

    methods: {
        filtroTabla(value, search, item) {
            if (!search) return true;
            const text = search.toString().toLowerCase();
            // Recorre TODAS las columnas del item
            return Object.values(item).some(val => {
                if (val === null || val === undefined) return false;

                return val
                    .toString()
                    .toLowerCase()
                    .includes(text);
            });
        },
        async descargarExcel() {
            if (!this.semestre) return;
            this.lgExcel = true; // Activar el indicador de carga
            DisponibilidadService.ReporteDispoComiXSemestre(this.semestre.Id).then((result) => {
                try {
                    // Crear un enlace para descargar el archivo
                    const url = window.URL.createObjectURL(new Blob([result.data]));
                    const link = document.createElement("a");
                    link.href = url;
                    // Definir el nombre del archivo
                    link.setAttribute("download", "ReporteDisponibilidad.xlsx");
                    // Agregar el enlace al DOM y hacer clic en él
                    document.body.appendChild(link);
                    link.click();
                    // Limpiar el enlace del DOM
                    link.remove();
                    this.lgExcel = false; // Desactivar el indicador de carga
                } catch (error) {
                    this.$toast.error("Error al descargar el archivo Excel");
                }
            }).catch((err) => {
                this.$toast.error("Error al descargar el archivo Excel");
                this.lgExcel = false; // Desactivar el indicador de carga
            });
        },
        async onExpand({ item, value }) {
            if (!value) return

            const docenteId = item.Id
            this.loadingRow = docenteId

            await DisponibilidadService.ObtenerDispoComiSemestreDetalle(this.semestre.Id, docenteId).then((result) => {
                this.details = {
                    ...this.details,
                    [docenteId]: result.data
                }
            }).catch((err) => {
                this.$toast.error(err.response.data);
            });
            this.loadingRow = null;

        },
        selectSemestre() {
            this.obtenerDatos();
        },
        async obtenerDatos() {
            if (!this.semestre) return;
            this.datos = [];
            await DisponibilidadService.ObtenerDispoComiSemestre(this.semestre.Id).then((result) => {
                this.datos = result.data;
            }).catch((err) => {
                this.$toast.error(err.response.data);
            });;
        }
    },
    mounted() {

    },
}
</script>


<style scoped>
.expanded-bg {
    display: block;
    width: 100%;
    background: #cfe4f966;
    border-top: 1px solid #d4e0f2;
    border-bottom: 1px solid #d4e0f2;
    border-radius: 0 0 4px 4px;
}

.fila {
    cursor: pointer;
}

.fila:hover {
    background: #f5f5f5;
}

.detalle {
    background: #eaf4ff;
    padding: 10px;
}
</style>
